import $http from '@/resource';

const $api = {};

/**
 * 获取 行政区划、所属区域、项目来源、专业类别 下拉备选项
 *
 * @method GET
 *
 * @param {Object} type 类型 1所属区域管理 2项目来源管理 3专业类别管理 4行政区划管理
 *
 * @returns {Promise<*>}
 *
 * @url /division
 */
$api.getDivision = async (type) => {
    let url = `/division?type=${type}`;
    return await $http.get(url);
};

/**
 * 企业名称 下拉备选项
 *
 * @method GET
 *
 * @returns {Promise<*>}
 *
 * @url /division
 */
$api.getCompanyName = async () => {
    let url = `/companys/name`;
    return await $http.get(url);
};

/**
 * 企业列表数据回收
 *
 * @method PATCH
 *
 * @returns {Promise<*>}
 *
 * @url /companys/status
 */
$api.companyRecycle = async (formData) => {
    let url = `/companys/status`;
    return await $http.patch(url,formData);
};


/**
 * 获取企业列表
 *
 * @method GET
 *
 * @param {Object} listData 搜索条件
 *
 * @returns {Promise<*>}
 *
 * @url /companys/list
 */
$api.getCompanysList = async (listData) => {
    let url = `/companys/list`;
    return await $http.get(url,{ params: listData });
};

/**
 * 获取企业列表最近搜索
 *
 * @method GET
 *
 * @returns {Promise<*>}
 *
 * @url /user/company-search-cache
 */
$api.getCompanySearch = async () => {
    let url = `/user/company-search-cache`;
    return await $http.get(url);
};

/**
 * 获取行业代码下拉备选项
 *
 * @method GET
 *
 * @returns {Promise<*>}
 *
 * @url /industry-code
 */
$api.getCodeList = async () => {
  let url = `/industry-code`;
  return await $http.get(url);
};

/**
 * 关注/取关企业
 *
 * @author zhangkaidong 2020-07-15 14:13:58
 *
 * @method GET
 *
 * @returns {Promise<*>}
 *
 * @url  /companys/{companyId}/focus
 */
$api.companysFocus = async (id,isFocus) => {

  let url = `/companys/${id}/focus`;
  let res = await $http.patch(url,{isFocus:isFocus=='1'?'2':'1'});
  return res;
}

/**
 * 获取企业详情
 *
 * @author zhangkaidong 2020-07-13 09:30:59
 *
 * @method GET
 *
 * @returns {Promise<*>}
 *
 * @url  companys/{id}/detail
 */
$api.getCompanyData = async (id) => {


  let url = `/companys/${id}/detail`;
  let res = await $http.get(url);
  return res;
}

/**
 * 获取企业标签
 *
 * @author zhangkaidong 2020-07-13 09:30:59
 *
 * @method GET
 *
 * @returns {Promise<*>}
 *
 * @url  companys/{id}/tags
 */
$api.getCompanyTags = async (id) => {

  let url = `companys/${id}/tags`;
  let res = await $http.get(url);
  return res;
}


/**
 * 删除标签
 *
 * @author zhangkaidong 2020-07-13 09:30:59
 *
 * @method GET
 *
 * @returns {Promise<*>}
 *
 * @url  item/${id}/tags
 */
$api.deleteCompanyTag = async (id,tags) => {

  let dict ={'tagid':tags}
  let url = `companys/${id}/tags`;
  let res = await $http.delete(url,{params:dict});
  return res;

}


/**
 * 添加标签
 *
 * @author zhangkaidong 2020-07-13 09:30:59
 *
 * @method POST
 *
 * @returns {Promise<*>}
 *
 * @url  companys/{id}/tags
 */
$api.addCompanyTag = async (id,tags) => {

  let url = `companys/${id}/tags`;
  let res = await $http.post(url,{'tagid':tags});
  return res;

};

/**
 * 获取企业回收记录
 *
 * @author zyz 2020-10-28 15:45:50
 *
 * @method GET
 *
 * @param {String} id 企业id
 * @param {int} page 页码数
 * @param {int} pageSize 单页条数
 *
 * @url /companys/
 *
 * @return {Promise<void>}
 */
$api.getCompanyRecycleRecord = async (id,page=1,pageSize=10) => {
    let url = `companys/${id}/recycle-record?page=${page}&pageSize=${pageSize}`;
    let res = await $http.get(url);
    return res;
};

export default $api;



// WEBPACK FOOTER //
// ./src/service/enterprise/enterprise.js